import { ClassAttributes, createElement, FC } from 'react';

import _HeadBar from '../component/compound/HeadBar';
import { Consumer as ConfigConsumer } from '../context/config';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as HistoryConsumer } from '../context/history';
import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement>;

const HeadBar: FC<Props> = () => (
  <DependencyConsumer>
    {(dependency) => (
      <HistoryConsumer>
        {(history) => (
          <StateConsumer>
            {(state) => (
              <ConfigConsumer>
                {(config) =>
                  !state.authentication.signedInUser || state.fatalError ? null : (
                    <_HeadBar
                      signedInUser={state.authentication.signedInUser}
                      language={state.language}
                      onClickLogo={() =>
                        history.location.pathname !== '/my_assignments' && history.push('/my_assignments')
                      }
                      onClickProjectsButton={() =>
                        history.location.pathname !== '/my_assignments' && history.push('/my_assignments')
                      }
                      onClickOffersButton={() => history.location.pathname !== '/offers' && history.push('/offers')}
                      hugotDirWebUrl={config.HUGOT_DIR_WEB_URL}
                      profileWebUrl={
                        state.authentication.signedInUser
                          ? `${config.PROFILE_WEB_URL}/users/${state.authentication.signedInUser.id}`
                          : `${config.PROFILE_WEB_URL}`
                      }
                      onClickSettings={() => history.push('/settings')}
                      onClickSignOut={() => dependency.authenticationUsecase.signOut()}
                      onClickAccountSettings={() => {
                        const url = `${config.ID_WEB_URL}`;
                        const win = window.open(url, '_blank');
                        if (win !== null) {
                          win.focus();
                        }
                      }}
                    />
                  )
                }
              </ConfigConsumer>
            )}
          </StateConsumer>
        )}
      </HistoryConsumer>
    )}
  </DependencyConsumer>
);

export default HeadBar;
